'use client'

import { useLocale } from 'next-intl'

import { useSearchFilterStore } from '@/entities/map'
import { mapManager, type StringDateRange } from '@/shared/lib'

import {
  convertToSearchHistory,
  type History,
} from '../model/search-history-store/history'
import { useSearchHistoryStore } from '../model/search-history-store/store'
import type { TLocation } from '../model/selected-location'

type CommitSearchParams = {
  keyword: string
  dateRange?: StringDateRange
  location?: TLocation | null
  onMapMoved?: () => void
}

export const useSearchExecution = () => {
  const locale = useLocale()
  const filterActions = useSearchFilterStore(state => state.actions)
  const historyActions = useSearchHistoryStore(state => state.actions)

  const commitSearch = ({
    keyword,
    dateRange,
    location,
    onMapMoved,
  }: CommitSearchParams) => {
    if (location?.lat && location?.lng) {
      mapManager.changeMapCenter({
        lat: location.lat,
        lng: location.lng,
        zoomLevel: location.nextZoomLevel,
      })
      onMapMoved?.()
    }

    historyActions.addSearchHistory(
      convertToSearchHistory({
        location: location ?? null,
        dateRange,
        locale,
      }),
    )

    filterActions.update({
      filters: {
        startDate: dateRange?.from ?? '',
        endDate: dateRange?.to ?? '',
      },
    })

    filterActions.update({ keyword })
  }

  const replayHistory = (history: History) => {
    if (history.location?.lat && history.location?.lng) {
      mapManager.changeMapCenter({
        lat: history.location.lat,
        lng: history.location.lng,
        zoomLevel: history.nextZoomLevel,
      })
    }

    historyActions.addSearchHistory(history)

    filterActions.update({
      filters: { startDate: history.startDate, endDate: history.endDate },
    })

    filterActions.update({ keyword: history.name })
  }

  return { commitSearch, replayHistory }
}
